module.exports = __webpack_public_path__ + "media/images/bg-lnav-arrow-94363916679ae0847e7e5d64d66d7963.svg";